
jQuery('.toggledown').click(function(){

  var parentDownlaods = jQuery('.dwl-wrapper').closest('.downlaods-shortcode');
  var refheightContainer = jQuery('.downlaods-shortcode .downloads_type:first-of-type');

  var refheight = refheightContainer.height();
  var contentHeight = refheight + 20;

  if(jQuery(this).attr('data-click-state') == 1) {
    jQuery(this).attr('data-click-state', 0)

    jQuery('.dwl-wrapper',parentDownlaods).animate({
      height: contentHeight
      }, 200, function(){
        jQuery(this).height(contentHeight);
    });
  
  } else {
    jQuery(this).attr('data-click-state', 1)
    jQuery('.dwl-wrapper',parentDownlaods).animate({
      height: jQuery('.dwl-wrapper',parentDownlaods).get(0).scrollHeight
      }, 200, function(){
        jQuery(this).height('auto');
    });
  }

});

jQuery('.togglepress').click(function(){

  var parentPresse = jQuery('.dwl-wrapper').closest('.archive-presse-shortcode');
  var refheightPress = jQuery('.archive-presse-shortcode .archive-item');
  var title = jQuery('.archive-presse-shortcode .archive-title');

  var refheightPr = refheightPress.first().outerHeight();
  var titleHeight = title.outerHeight();
  var pressHeight = parseInt(refheightPr)* 2;
  var pressHeightFin = pressHeight + titleHeight;

  if(jQuery(this).attr('data-click-state') == 1) {
    jQuery(this).attr('data-click-state', 0)
    jQuery('.dwl-wrapper',parentPresse).animate({
      height: pressHeightFin
      }, 200, function(){
        jQuery(this).height(pressHeightFin);
    });
  
  } else {
    jQuery(this).attr('data-click-state', 1)
    jQuery('.dwl-wrapper',parentPresse).animate({
      height: jQuery('.dwl-wrapper',parentPresse).get(0).scrollHeight
      }, 200, function(){
        jQuery(this).height('auto');
    });
  }

});

jQuery(function($){
  $(document).ready(function() {

    var parentDownlaods = $('.dwl-wrapper').closest('.downlaods-shortcode');
    var parentPresse = $('.dwl-wrapper').closest('.archive-presse-shortcode');

    var refheightContainer = $('.downlaods-shortcode .downloads_type');
    var refheightPress = $('.archive-presse-shortcode .archive-item');
    var title = $('.archive-presse-shortcode .archive-title');

    $(window).resize(function() {
      var refheight = refheightContainer.outerHeight();
      var contentHeight = refheight + 20;

      var refheightPr = refheightPress.first().outerHeight();
      var titleHeight = title.outerHeight();

      var pressHeight = parseInt(refheightPr)* 2;
      var pressHeightFin = pressHeight + titleHeight;
      
      $('.dwl-wrapper',parentDownlaods).height(contentHeight);
      $('.dwl-wrapper',parentPresse).height(pressHeightFin);

    });
  
    $(window).trigger('resize');
  
  });

});


jQuery.extend(true, jQuery.magnificPopup.defaults, {
  tClose: 'schließen' // Alt text on close button
  /*
  tLoading: 'Loading...', // Text that is displayed during loading. Can contain %curr% and %total% keys
  gallery: {
    tPrev: 'Previous (Left arrow key)', // Alt text on left arrow
    tNext: 'Next (Right arrow key)', // Alt text on right arrow
    tCounter: '%curr% of %total%' // Markup for "1 of 7" counter
  },
  image: {
    tError: '<a href="%url%">The image</a> could not be loaded.' // Error message when image could not be loaded
  },
  ajax: {
    tError: '<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
  }
  */
});


jQuery('.servicelink').magnificPopup({
  type:'inline',
  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  key: 'article',
  gallery: {
    enabled:true
  },
  closeBtnInside: true,
  showCloseBtn: true,
  mainClass: 'adac-modal'
});

jQuery('.servicesclose').magnificPopup({
  type:'inline',
  midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
  key: 'form',
  closeBtnInside: true,
  showCloseBtn: true,
  mainClass: 'adac-modal no-arrows'
});

/*jQuery('.servicesclose').click(function() {
  jQuery.magnificPopup.close(); // Close popup that is currently opened (shorthand)
});
*/